import './styles.css'; // the page base, before the front page's own stylesheet
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

/*
 * The eager entry is the front page only (ADR-040): each game is a lazily loaded app, and the
 * library settings for the deployed CSP (`cspCompat.ts`) load first inside the app that needs them.
 */
const container = document.getElementById('root');
if (!container) throw new Error('#root element missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
